export const ProgressStepStateEnum = {
    IDLE: 'idle',
    ACTIVE: 'active',
    DONE: 'done',
    DISABLED: 'disabled',
} as const;

export type ProgressStepState = (typeof ProgressStepStateEnum)[keyof typeof ProgressStepStateEnum];
